interface ParamErrorProps {
  message?: string;
  type?: string;
}

export class MedicationScheduleParams {
  static paramError: ParamErrorProps | null;
}
